import React, {Component} from 'react';
import firebase from "../../firebase";
import {Link} from "react-router-dom";
import * as routes from "../../constants/routes";
import logo from "../../img/logo.svg";
import queryString from "query-string";


class ResetPassword extends Component {

    state = {
        oobCode: '',
        password: '',
        passwordConfirm: '',
        passwordError: false,
        errorMessage: '',
        btnDisabled: false,
        btnLoading: false,
        resetSuccess: false
    };

    componentWillMount(){
        const parsedParams = queryString.parse(window.location.search);
        if(parsedParams.oobCode){
            this.setState({
                oobCode: parsedParams.oobCode
            });
        }
    }

    componentDidMount = () => {
        if (this.passwordInput) {
            this.passwordInput.focus();
        }
    };

    validateForm = () => {

        if(!(this.state.password.length >= 6)){
            this.setState({
                btnLoading: false,
                passwordError: true,
                btnDisabled: false,
                errorMessage: "Password should be at least 6 characters long."
            });
            return false;
        }

        if(this.state.password !== this.state.passwordConfirm){
            this.setState({
                btnLoading: false,
                passwordError: true,
                btnDisabled: false,
                errorMessage: "Please insert same password for both fields."
            });
            return false;
        }

        return true;
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            passwordError: false
        });
    };

    handleSubmit = (e) => {

        e.preventDefault();
        e.stopPropagation();

        // loading
        this.setState({
            btnLoading: true,
            btnDisabled: true
        });

        // valiadate form
        if(!this.validateForm()){
            return;
        }

        // Verify the password reset code is valid.
        firebase.auth().verifyPasswordResetCode(this.state.oobCode).then((email) => {
            // Save the new password.
            firebase.auth().confirmPasswordReset(this.state.oobCode, this.state.password).then((resp) => {
                // Password reset has been confirmed and new password updated.
                // if the page belongs to the same domain as the app:
                //firebase.auth().signInWithEmailAndPassword(email, this.state.password);

                // success
                this.setState({
                    errorMessage: '',
                    resetSuccess: true,
                    btnLoading: false
                });
            }).catch((error) => {
                // Error occurred during confirmation. The code might have expired or the
                // password is too weak.
                this.setState({
                    errorMessage: error.message,
                    btnLoading: false,
                    btnDisabled: false
                });
            });
        }).catch((error) => {
            // Invalid or expired action code. Ask user to try to reset the password
            // again.
            let message = error.message;

            if(error.code === 'auth/expired-action-code'){
                message = "Password reset token has expired! Please request a password reset email again.";
            }

            this.setState({
                errorMessage: message,
                btnLoading: false,
                btnDisabled: false
            });
        });
    };

    render() {

        const {password, passwordConfirm, passwordError, errorMessage, btnLoading, btnDisabled, resetSuccess} = this.state;

        return (
            <div className="quiz">
                <div className="quiz__left-side">
                    <div className="quiz__area">

                        <div className="form">

                            <h1 className="form__title">Reset Password</h1>

                            <p className="form__desc">Please set a new password for your account.</p>

                            <form method="post" className="form__wrapper reset_password__form">

                                {!resetSuccess &&
                                <div className="__input_group">
                                    <div className="form__input-area">
                                        <label htmlFor="password" className="form__label">New Password</label>
                                        <input
                                            type="password"
                                            id="password"
                                            name="password"
                                            className={'form__input' + (passwordError ? ' input-error' : '')}
                                            ref={(pass) => {
                                                this.passwordInput = pass;
                                            }}
                                            value={password}
                                            onChange={this.handleChange}
                                            onBlur={this.handleChange}
                                        />
                                    </div>
                                    <div className="form__input-area">
                                        <label htmlFor="passwordConfirm" className="form__label">Confirm Password</label>
                                        <input
                                            type="password"
                                            id="passwordConfirm"
                                            name="passwordConfirm"
                                            className={'form__input' + (passwordError ? ' input-error' : '')}
                                            value={passwordConfirm}
                                            onChange={this.handleChange}
                                            onBlur={this.handleChange}
                                        />
                                    </div>
                                </div>
                                }

                                {errorMessage &&
                                <div className="clear">
                                    <p className="error__message">* {errorMessage}</p>
                                </div>
                                }

                                {resetSuccess &&
                                <div className="clear">
                                    <h3 className="color__purple">Password reset was successful.</h3>
                                    <p className="color__purple">You can sign in with your new password now.</p>
                                </div>
                                }

                                <button
                                    type="submit"
                                    className={`button button_send-form ` + (btnLoading ? 'loading__btn' : '')}
                                    onClick={this.handleSubmit}
                                    disabled={btnDisabled}
                                >Reset Password</button>

                            </form>

                            <p className="form__additional">
                                Back to <Link to={routes.SIGN_IN}>Sign in</Link>
                            </p>

                        </div>

                    </div>
                </div>

                <div className="quiz__right-side">
                    <img src={logo} alt="" className="quiz__right-side-logo"/>

                    <div className="phone-container">
                        <div className="phone">
                            <div className="screen">
                                <div className="screen__number-container">
                                    <p className="screen__number">0</p>
                                    <p className="screen__number-text">complete</p>
                                </div>
                            </div>
                        </div>
                        <div className="phone-container__marker phone-container__marker_vitta">Vata</div>
                        <div className="phone-container__marker phone-container__marker_pitta">Pitta</div>
                        <div className="phone-container__marker phone-container__marker_kapha">Kapha</div>
                    </div>

                </div>
            </div>
        );
    }
}

export default ResetPassword;


// WEBPACK FOOTER //
// ./src/components/Account/ResetPassword.js